import {
	friendInvitationAccept,
	friendInvitationAddByRef,
	friendInvitationCreate,
} from "@/shared/api/generated-social"

export async function createInvitation(userId: number, demean: string) {
	return friendInvitationCreate({
		body: { user_id: userId, demean },
	})
}

export async function addInvitationByRef(refCode: string) {
	await friendInvitationAddByRef({
		body: { tg_ref_code: refCode },
	})
}

export async function acceptFriendInvitation(
	userId: number,
	invitationId: number,
) {
	await friendInvitationAccept({
		body: { user_id: userId, invitation_id: invitationId },
	})
}
